// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.highcharts-figure, .highcharts-data-table table {
    min-width: 320px;
    max-width: 800px;
    margin: 1em auto;
}

.highcharts-data-table table {
    font-family: Verdana, sans-serif;
    border-collapse: collapse;
    border: 1px solid #EBEBEB;
    margin: 10px auto;
    text-align: center;
    width: 100%;
    max-width: 500px;
}
.highcharts-data-table caption {
    padding: 1em 0;
    font-size: 1.2em;
    color: #555;
}
.highcharts-data-table th {
    font-weight: 600;
    padding: 0.5em;
}
.highcharts-data-table td, .highcharts-data-table th, .highcharts-data-table caption {
    padding: 0.5em;
}
.highcharts-data-table thead tr, .highcharts-data-table tr:nth-child(even) {
    background: #f8f8f8;
}
.highcharts-data-table tr:hover {
    background: #f1f7ff;
}

.popupChart{
    width:200px; height:200px;
}

.infoContent{
    overflow:hidden;
    width:0;
    height:0;
}

.popupStats{
    font-size:0.8em;
}

.mapboxgl-popup-content{
    background:rgba(0,0,0,0.8);
    padding: 5px 20px 5px 5px;
    width:fit-content;
    font-size:1.3em;
    color:white;
    text-align:center;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.mapboxgl-popup-anchor-top .mapboxgl-popup-tip{
    border-bottom-color:black;
}
.mapboxgl-popup-content{
    border:solid white 1px;
}

.mapboxgl-popup-close-button{
    background-color:white !important;
}

.mapboxgl-popup-tip {
    border-top-color:orange !important;
}`, "",{"version":3,"sources":["webpack://./src/css/visdialogs.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW,EAAE,YAAY;AAC7B;;AAEA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW;IACtC,wBAAwB,EAAE,mBAAmB;IAC7C,sBAAsB,EAAE,4BAA4B;IACpD,qBAAqB,EAAE,2BAA2B;IAClD,iBAAiB,EAAE;gFACyD;AAChF;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":["\n.highcharts-figure, .highcharts-data-table table {\n    min-width: 320px;\n    max-width: 800px;\n    margin: 1em auto;\n}\n\n.highcharts-data-table table {\n    font-family: Verdana, sans-serif;\n    border-collapse: collapse;\n    border: 1px solid #EBEBEB;\n    margin: 10px auto;\n    text-align: center;\n    width: 100%;\n    max-width: 500px;\n}\n.highcharts-data-table caption {\n    padding: 1em 0;\n    font-size: 1.2em;\n    color: #555;\n}\n.highcharts-data-table th {\n    font-weight: 600;\n    padding: 0.5em;\n}\n.highcharts-data-table td, .highcharts-data-table th, .highcharts-data-table caption {\n    padding: 0.5em;\n}\n.highcharts-data-table thead tr, .highcharts-data-table tr:nth-child(even) {\n    background: #f8f8f8;\n}\n.highcharts-data-table tr:hover {\n    background: #f1f7ff;\n}\n\n.popupChart{\n    width:200px; height:200px;\n}\n\n.infoContent{\n    overflow:hidden;\n    width:0;\n    height:0;\n}\n\n.popupStats{\n    font-size:0.8em;\n}\n\n.mapboxgl-popup-content{\n    background:rgba(0,0,0,0.8);\n    padding: 5px 20px 5px 5px;\n    width:fit-content;\n    font-size:1.3em;\n    color:white;\n    text-align:center;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none; /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}\n\n.mapboxgl-popup-anchor-top .mapboxgl-popup-tip{\n    border-bottom-color:black;\n}\n.mapboxgl-popup-content{\n    border:solid white 1px;\n}\n\n.mapboxgl-popup-close-button{\n    background-color:white !important;\n}\n\n.mapboxgl-popup-tip {\n    border-top-color:orange !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
